import React from 'react';
import { Outlet } from 'react-router-dom';
import Toast from 'src/components/Toast/Toast';

const Layout: React.FC = () => {
  return (
    <>
      <Outlet />
      <Toast />
    </>
  );
};

export default Layout;
